import React, { useEffect, useState } from "react";
import { AUDIT_CALLING_REPORT, OUTGOING_CALL_REPORT } from "../../constants";
import axios from "axios";
import dayjs from "dayjs";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../reusable Component/Loader";
import { Box, Breadcrumbs, IconButton, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DetailsFilterComponent from "./DetailsFilterComponent";
import DataDisplayCard from "./DataDisplayCard";

const ParivartanAgentOutgoingCallDetails = ({}) => {
  const [loading, setLoading] = useState(false);

  const { agentName } = useParams();
console.log(agentName);

  const location = useLocation();
  const { prevFilters } = location.state || {}; // Access filters from the state
  
  const [callStatistics, setCallStatistics] = useState([]);
  const [metricData, setMetricData] = useState([]);
  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(7, "days").toDate(), // 7 days ago
    endDate: dayjs().toDate(), // Today
  });

  useEffect(() => {
    fetchCallStatistics();
  }, [filters]); // Fetch data whenever filters change

  useEffect(() => {
    if (prevFilters) {
      setFilters(prevFilters); // Initialize filters with prevfilters if available
    }
  }, [prevFilters]);

  const fetchCallStatistics = () => {
    const { startDate, endDate } = filters;
    setLoading(true);

    // Determine yesterday's date
    const last7days = dayjs().subtract(7, "days").toDate();

    // Format startDate and endDate, defaulting to yesterday if not provided
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : last7days;
    const formattedEndDate = endDate
      ? dayjs(endDate).format("YYYY-MM-DD")
      : dayjs().toDate();

    // Build query params
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    queryParams.append("agentName", agentName);
    queryParams.append("ivrNumber", 8517009997);

    axios
      .get(`${OUTGOING_CALL_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { data } = response.data;
        setCallStatistics(data.agents);
        setMetricData(data.summary.metrics);
        console.log(response.data.data.summary);

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const [filterShow, setFilterShow] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link underline="hover" key="1" color="inherit" to="/outgoing_calling_report">
          Outgoing Call Report
        </Link>
        <Typography key="2" color="primary">
          Details
        </Typography>
      </Breadcrumbs>
      {/* Container with flex layout to align items */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          width: "100%",
        }}
      >
        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Box>

      {filterShow && (
        <DetailsFilterComponent
          filters={filters}
          setFilters={setFilters}
          setFilterShow={setFilterShow}
        />
      )}

      <DataDisplayCard callStatistics={callStatistics} metricData={metricData}></DataDisplayCard>
    </>
  );
};

export default ParivartanAgentOutgoingCallDetails;
